import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { Checkbox, Tooltip, TooltipSkin } from 'wix-ui-tpa/cssVars';
import { useFormActions } from '../../Hooks/useFormActions';
import { classes } from './BookForSomeoneElseCheckbox.st.css';
import { BookForSomeoneElseCheckboxDataHooks } from './dataHooks';

export interface BookForSomeoneElseCheckboxProps {
  isBookingForSomeoneElse: boolean;
  isPricingPlanSelected?: boolean;
  /** Locks the checkbox (e.g. participants after the first are always someone else). */
  disabled?: boolean;
}

const BookForSomeoneElseCheckbox: React.FC<BookForSomeoneElseCheckboxProps> = ({
  isBookingForSomeoneElse,
  isPricingPlanSelected,
  disabled,
}) => {
  const { t } = useTranslation();
  const { setIsBookingForSomeoneElse } = useFormActions();

  const checkbox = (
    <Checkbox
      className={classes.checkbox}
      data-hook={BookForSomeoneElseCheckboxDataHooks.CHECKBOX}
      checked={isBookingForSomeoneElse}
      disabled={isPricingPlanSelected || disabled}
      label={t('bookings.form.bookForSomeoneElse.checkbox.label')}
      onChange={({ checked }) => setIsBookingForSomeoneElse(checked)}
    />
  );

  return isPricingPlanSelected ? (
    <Tooltip
      skin={TooltipSkin.Wired}
      content={t(
        'bookings.form.bookForSomeoneElse.checkbox.pricingPlanDisabledTooltip',
      )}
      className={classes.tooltip}
      data-hook={BookForSomeoneElseCheckboxDataHooks.TOOLTIP}
      minWidth={200}
    >
      {/* Wrap in a block so the tooltip target still receives hover events
          while the checkbox itself is disabled. */}
      <div className={classes.tooltipTarget}>{checkbox}</div>
    </Tooltip>
  ) : (
    checkbox
  );
};

export default BookForSomeoneElseCheckbox;
